import { render, staticRenderFns } from "./ResultsHistoryMainView.vue?vue&type=template&id=f191ede8"
import script from "./ResultsHistoryMainView.vue?vue&type=script&lang=js"
export * from "./ResultsHistoryMainView.vue?vue&type=script&lang=js"
import style0 from "./ResultsHistoryMainView.vue?vue&type=style&index=0&id=f191ede8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports